$(function () {
    $('.points-row').slick({
        dots       : true,
        mobileFirst: true,
        infinite   : false,
        arrows     : false,
        responsive : [
            {
                breakpoint: 767,
                settings  : "unslick"
            }
        ]
    })
})
